// extracted by mini-css-extract-plugin
export default {"small":"b5+9up9aA8+TSbcmpMAN1A==","large":"K8HWECklIXQbTJqs1gVF8A=="};